// Shared config for the CV-submit success animation, used by both the in-app
// @remotion/player and the Remotion <Composition> that the CLI renders to mp4.
export const CV_SUCCESS = {
  id: 'cv-success',
  fps: 30,
  durationInFrames: 105, // ~3.5s
  width: 600,
  height: 600
} as const;

// Brand values inlined (not imported from the MUI theme) so the composition renders
// identically inside the Remotion bundler, which has no access to the app's ThemeProvider.
export const BRAND = {
  blue: '#2D31FF',
  white: '#FFFFFF'
} as const;
